import { render, staticRenderFns } from "./PathNotActive.vue?vue&type=template&id=16fe0456&"
import script from "./PathNotActive.vue?vue&type=script&lang=js&"
export * from "./PathNotActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports